module.exports = __webpack_public_path__ + "img/task-1.991e0bc1.png";